export default {
  'invalid or expired jwt':
    'Sua sessão expirou. Você será redicionado para o início. Por favor, tente novamente.'
}
